import { JSONSchema7 } from 'json-schema';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import ControlKind from '../../Shared/controlKind';
import upgradeControl from './upgradeControl';
import controlDictionary from '../../Controls/controlDictionary';

export default (pageSchema: JSONSchema7): JSONSchema7 => {
  const pageProperties = pageSchema.properties as JSONSchema7Properties;

  Object.getOwnPropertyNames(pageProperties).forEach((propName: string) => {
    const controlSchema = pageProperties[propName] as JSONSchema7;
    const controlProperties = controlSchema.properties as JSONSchema7Properties;
    const typeSchema = controlProperties['type'] as JSONSchema7;
    const controlType = typeSchema.default as ControlKind;

    if (controlType === ControlKind.PAGE) {
      return pageSchema;
    }

    const pageExternalId = pageSchema.$id as string;
    const controlId = controlSchema.$id?.split('/')[1] as string;
    const order = (controlProperties['order'] as JSONSchema7).default as number;
    const controlConfig = controlDictionary[controlType];

    if (!controlConfig) {
      return pageSchema;
    }

    const latestSchema = controlDictionary[controlType].getLatestSchema(
      controlId,
      pageExternalId,
      order
    );

    const translator = controlDictionary[controlType].translator;

    pageProperties[propName] = upgradeControl(
      controlSchema,
      latestSchema,
      translator
    );
  });

  return {
    ...pageSchema,
    properties: pageProperties
  };
};
